import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import { Translations } from "@avinet/adaptive-ui-translate/TranslatorProvider";
import { en } from "../translations/en";
import { no } from "../translations/no";

export function useBrowserLanguage(): Translations {
  const lang = (window.navigator.language || "").substr(0, 2).toLowerCase();
  const [userLang] = useSyncedLocalStorage("lang");

  switch (userLang ?? "") {
    case "nb":
    case "no":
    case "nn":
      return no;
    case "en":
      return en;
  }

  switch (lang) {
    case "nb":
    case "no":
    case "nn":
      return no;
    default:
      return en;
  }
}
